import { toSnakeCase } from "@shared/utils/caseConverter";

export const bxPrintingDistributionUtils = {
  convertToSnakeCase(data: any): any {
    if (Array.isArray(data)) {
      return data.map((item) =>
        bxPrintingDistributionUtils.convertToSnakeCase(item)
      );
    }

    if (data !== null && typeof data === "object") {
      const converted: Record<string, any> = {};
      Object.entries(data).forEach(([key, value]) => {
        const snakeKey = toSnakeCase(key);
        converted[snakeKey] =
          bxPrintingDistributionUtils.convertToSnakeCase(value);
      });
      return converted;
    }

    return data;
  },
};
